import { Injectable } from '@angular/core';

import { ApiService, AppContext, LogService, BillingService, UserService, Coupon } from './../../shared';
import { Customer } from './../../shared/models/customer';

@Injectable()
export class UpdatePlanService {
  title: string = 'Change Your Plan';
  show: boolean = false;

  accountType: string = '';
  billingPeriod: string = '';

  cost: string = '';
  plan: string = 'Basic';

  public showCancel = false;

  status: string = '';
  cancelSuccess: boolean = false;

  public showSubscribe = false;
  subscribeSuccess: boolean = false;

  coupon: string = '';
  freeAccount: boolean = false;
  costMultiplier: number = 1;

  couponValid: boolean = false;
  couponError: string = '';

  buttonEnabled: boolean = false;
  newPlan: string = 'Basic';


  hasCard: boolean = false;

  constructor(private api: ApiService, private app: AppContext, private logger: LogService,
    private billing: BillingService, private user: UserService) {
    this.init();
  }

  init() {
    this.billing.getCustomer().then((customer: Customer) => {
      try {
        if (this.app.accountType == 'Basic') {
          this.accountType = 'Professional';
          this.billingPeriod = 'Monthly';
        } else if (this.app.plan.id.indexOf('api') > -1) {
          let planArray = this.app.plan.id.split('-');

          if (planArray[1] == '500') {
            this.accountType = 'Professional + API(500)';
          } else if (planArray[1] == '1000') {
            this.accountType = 'Professional + API(1000)';
          } else if (planArray[1] == '1500') {
            this.accountType = 'Professional + API(1500)';
          } else if (planArray[1] == '4000') {
            this.accountType = 'Professional + API(4000)';
          } else if (planArray[1] == '15000') {
            this.accountType = 'Professional + API(15000)';
          } else if (planArray[1] == '50000') {
            this.accountType = 'Professional + API(50000)';
          } else if (planArray[1] == '150000') {
            this.accountType = 'Professional + API(150000)';
          } else {
            this.accountType = 'Professional';
          }
        } else {
          this.accountType = this.app.accountType;
          this.billingPeriod = this.app.billingInterval == 'month' ? 'Monthly' : 'Yearly';
        }

        this.hasCard = customer.sources.length > 0;
      } catch (ex) {
        this.hasCard = false;
      }

      this.updateView();
    }).catch(err => {
      this.hasCard = false;
      this.updateView();
    });
  }

  open(toDisplay: boolean) {
    this.show = toDisplay;
    this.init();
  }

  close() {
    this.coupon = '';
    this.costMultiplier = 1;
    this.couponValid = false;
    this.couponError = '';
    this.freeAccount = false;
    this.hasCard = false;
    this.couponError = '';

    this.showCancel = false;
    this.cancelSuccess = false;

    this.showSubscribe = false;
    this.subscribeSuccess = false;

    this.status = '';
    this.cost = '';
  }

  updateView() {
    this.validate();

    this.updateCost();
  }

  updateCost() {
    let cost = '';
    if (this.accountType === 'Premium') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(49 * this.costMultiplier).toFixed(2)} in 14 days`;
        this.plan = 'monthly-premium';
      } else {
        cost = `You will be charged $${(488 * this.costMultiplier).toFixed(2)} in 14 days`;
        this.plan = 'yearly-premium';
      }
    } else if (this.accountType === 'Professional') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(99 * this.costMultiplier).toFixed(2)} in 14 days`;
        this.plan = 'monthly-professional';
      } else {
        cost = `You will be charged $${(988 * this.costMultiplier).toFixed(2)} in 14 days`;
        this.plan = 'yearly-professional';
      }
    } else if (this.accountType === 'Enterprise 2-6 users') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(149 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HUDlXBI16lWsbHUpazF2axJ';
      } else {
        cost = `You will be charged $${(1488 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HrW7lBI16lWsbHUsNT327Sp';
      }
    } else if (this.accountType === 'Enterprise 7-12 users') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(199 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HUDrpBI16lWsbHUEcy8QqRp';
      } else {
        cost = `You will be charged $${(1988 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HtzNJBI16lWsbHUF6DRNf0X';
      }
    } else if (this.accountType === 'Enterprise 13-18 users') {
      if (this.billingPeriod === 'Monthly') {
        cost = `You will be charged $${(249 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HUDwiBI16lWsbHUJUXFNMp2';
      } else {
        cost = `You will be charged $${(2488 * this.costMultiplier).toFixed(2)}`;
        this.plan = 'price_1HtzKUBI16lWsbHU4gyZlwmJ';
      }
    } else if (this.accountType === 'API-500 + Enterprise') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(330 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzaGCAIBqfWZikF50UOobO';
    } else if (this.accountType === 'API-1500 + Enterprise') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(550 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzdlCAIBqfWZikTr54Oj54';
    } else if (this.accountType === 'API-4000 + Enterprise') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(1000 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzh3CAIBqfWZikkmKsljAm';
    } else if (this.accountType === 'API-15000 + Enterprise') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(1990 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzicCAIBqfWZikm7knIDYs';
    } else if (this.accountType === 'API-50000 + Enterprise') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(3600 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzlWCAIBqfWZikOzC01OKm';
    } else if (this.accountType === 'API-150000 + Enterprise') {
      this.billingPeriod = 'Monthly';
      cost = `You will be charged $${(4900 * this.costMultiplier).toFixed(2)}`;
      this.plan = 'price_1KDzoOCAIBqfWZik4wgvO1ZZ';
    }

    if (!this.hasCard && !this.freeAccount && this.couponValid) {
      // has no card and is using a non-free-account coupon
      this.cost = 'Please add a credit card before subscribing with that coupon.'
    } else {
      this.cost = this.freeAccount ? 'FREE ACCOUNT' : cost;
    }
  }

  checkCoupon() {
    this.couponValid = false;
    this.couponError = '';

    if (this.validateCoupon()) {
      this.logger.log('update-plan.service', 'checkCoupon', 'before call');
      this.callCheckCoupon();
    }
  }

  validateCoupon(): boolean {
    if (this.coupon.length === 0 || this.coupon.length > 256) {
      return false;
    }
    return true;
  }

  callCheckCoupon() {
    this.billing.checkCoupon(this.coupon).then((coupon: Coupon) => {
      if (coupon.percentOff == 100) {
        // free account
        this.freeAccount = true;
        this.couponValid = true;
      } else if (coupon.percentOff !== 0 && coupon.percentOff) {
        this.costMultiplier = 1 - (coupon.percentOff / 100);
        this.couponValid = true;
      } else {
        this.couponError = 'Invalid Coupon';
        this.couponValid = false;
      }
      this.updateView();
    }).catch((err) => {
      this.couponError = 'Invalid Coupon';
      this.couponValid = false;
    });
  }

  validate() {
    // is a change
    // has card or is free

    let intervalChange = false;
    if (this.billingPeriod === 'Yearly' && this.app.billingInterval !== 'year') {
      intervalChange = true;
    }
    if (this.billingPeriod === 'Monthly' && this.app.billingInterval !== 'month') {
      intervalChange = true;
    } else if (this.billingPeriod === 'Monthly' && this.app.billingInterval === 'month') {
      intervalChange = false;
    }

    try {
      this.buttonEnabled = ((intervalChange || this.isTypeChange()) && (this.hasCard || this.freeAccount)) || this.couponValid;
    } catch (ex) {
      this.buttonEnabled = false;
    }
  }

  isTypeChange(): boolean {
    let currentAccountType = this.app.accountType;
    let currentPlan = this.app.plan.id;

    if (this.app.plan.id.indexOf('api') > -1) {
      let planArray = this.app.plan.id.split('-');

      if (planArray[1] == '500') {
        currentAccountType = 'Professional + API(500)';
      } else if (planArray[1] == '1000') {
        currentAccountType = 'Professional + API(1000)';
      } else if (planArray[1] == '1500') {
        currentAccountType = 'Professional + API(1500)';
      } else if (planArray[1] == '4000') {
        currentAccountType = 'Professional + API(4000)';
      } else if (planArray[1] == '15000') {
        currentAccountType = 'Professional + API(15000)';
      } else if (planArray[1] == '50000') {
        currentAccountType = 'Professional + API(50000)';
      } else if (planArray[1] == '150000') {
        currentAccountType = 'Professional + API(150000)';
      }
    }

    return currentAccountType != this.accountType;
  }

  toggleSubscribe() {
    this.showSubscribe = !this.showSubscribe;
  }

  subscribe() {
    this.validate();
    if (this.status === 'sending...' || !this.buttonEnabled) {
      return;
    }

    this.status = 'sending...';
    this.subscribeSuccess = false;

    let coupon = '';
    if (this.couponValid) {
      coupon = this.coupon;
    }

    this.billing.subscribe(this.plan, coupon)
      .then(subscription => {
        this.app.setAccountType(this.accountType);
        if (this.billingPeriod === 'Monthly') {
          this.app.plan.interval = 'month';
        }
        if (this.billingPeriod === 'Yearly') {
          this.app.plan.interval = 'year';
        }
        this.user.getProfile();
        this.subscribeSuccess = true;
        this.status = 'success';
      }).catch(err => {
        this.logger.log('update-plan.service', 'changePlan error', err);
        if (typeof err == 'string') {
          this.status = err;
        } else {
          this.status = 'something went wrong';
        }
        this.subscribeSuccess = false;
      });
  }

  toggleCancel() {
    this.showCancel = !this.showCancel;
  }

  cancelPlan(): Promise<any> {
    if (this.status === 'sending...') {
      return;
    }

    this.status = 'sending...';
    this.cancelSuccess = false;

    this.billing.cancel()
      .then(result => {
        this.logger.log('update-plan.service', 'cancelPlan success', result);
        this.user.getProfile();
        this.app.setAccountType('Basic');
        this.app.plan.interval = '';
        this.cancelSuccess = true;
        this.status = 'success';
      }).catch(err => {
        this.logger.log('update-plan.service', 'cancelPlan error', err);
        this.status = 'error';
        this.cancelSuccess = false;
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/update-plan/update-plan.service.ts